import { getLeaseToken } from './leaseToken';
import type { Store } from 'vuex';
import { LeaseManager } from './LeaseManager';
import {
  getLeaseFromApi,
  liberateLease,
  returnLeaseToApi,
  getTrialAvailability,
  refreshLoginToKickLease,
} from './leaseApi';

// eslint-disable-next-line @typescript-eslint/init-declarations
let leaseManager: LeaseManager;

// The app has only a single LeaseManager instance for the active user
const getLeaseManager = (store: Store<any>) => {
  if (leaseManager) return leaseManager;

  leaseManager = new LeaseManager(store, {
    getLeaseFromApi,
    liberateLease,
    returnLeaseToApi,
    refreshLoginToKickLease,
  });

  return leaseManager;
};

export { getLeaseToken, getTrialAvailability, refreshLoginToKickLease, getLeaseManager };
